import React, { useState } from "react";
import ModalWrapper from "../../../app/common/modals/ModalWrapper";
import { DROP_DOWN_JOB_TYPE_OPTIONS, getJobType } from "../helpers/jobTypes";
import { Button, Dropdown } from "semantic-ui-react";
import { MAIN_COLOUR, WHITE_COLOUR } from "../../../css/styles";
import {
  getJobs,
  getJobIndustryFilter,
  getJobTypeFilter,
} from "../jobsSelectors";
import { useDispatch, useSelector } from "react-redux";
import {
  deselectJobIndustryFilter,
  deselectJobTypeFilter,
  selectFloatButton,
  selectJobIndustryFilter,
  selectJobTypeFilter,
  setHrMode,
  setShowRecentJobs,
} from "../jobsActions";
import { selectViewListModeJob, setClusteredMap } from "../../map/mapActions";
import ReactGA from "react-ga4";
import { getMap } from "../../map/mapSelector";
import { getJobIndustry, HEALTHCARE_INDUSTRY } from "../helpers/jobIndustries";
import { closeModal } from "../../../app/common/modals/modalReducer";
import { getJobFilterOptions } from "../../modes/helpers";
import { HR_ALL_MODE, HR_HEALTHCARE_MODE } from "../../modes/constants";
import { JOBS_ROUTE } from "../../../app/api/routeConstants";
import { useHistory } from "react-router-dom";

const JOB_TYPE_FILTER = 1;
const INDUSTRY_FILTER = 2;

export default function MobileJobFiltersModal() {
  const dispatch = useDispatch();
  const history = useHistory();

  const { isCookieConsent } = useSelector((state) => state.app);
  const { mode, filters, isShowRecentJobs } = useSelector((state) =>
    getJobs(state)
  );
  const { viewListModeJob } = useSelector((state) => getMap(state));

  const typeToFilter = getJobTypeFilter(filters);
  const industryToFilter = getJobIndustryFilter(filters);

  const [buttonOpen, setButtonOpen] = useState(0);

  function handleFilterClick(filter, e) {
    e.stopPropagation();
    if (buttonOpen === filter) {
      setButtonOpen(0);
    } else {
      setButtonOpen(filter);
    }
  }

  function handleJobTypeChange(e, { value }) {
    if (value === "") {
      dispatch(deselectJobTypeFilter());
    } else {
      dispatch(selectJobTypeFilter(value));
      isShowRecentJobs && dispatch(setShowRecentJobs(false));
    }

    dispatch(selectFloatButton(null));

    if (viewListModeJob !== null) {
      dispatch(selectViewListModeJob(null));
      dispatch(setClusteredMap(true));
    }

    if (isCookieConsent) {
      ReactGA.event({
        category: "Filter",
        action: "Job type",
        label: getJobType(value),
      });
    }
  }

  function handleIndustryChange(e, { value }) {
    if (value === "") {
      dispatch(deselectJobIndustryFilter());
    } else if (value === HEALTHCARE_INDUSTRY) {
      dispatch(setHrMode(HR_HEALTHCARE_MODE));
      window.scrollTo(0, 0);
      history.push(JOBS_ROUTE);
      dispatch(closeModal());
    } else {
      dispatch(selectJobIndustryFilter(value));
      isShowRecentJobs && dispatch(setShowRecentJobs(false));
    }

    dispatch(selectFloatButton(null));

    if (viewListModeJob !== null) {
      dispatch(selectViewListModeJob(null));
      dispatch(setClusteredMap(true));
    }

    if (isCookieConsent) {
      ReactGA.event({
        category: "Filter",
        action: "Job category",
        label: getJobIndustry(value),
      });
    }
  }

  return (
    <ModalWrapper
      style={{ width: "98%", padding: 0 }}
      modalClassName="modal-ux-wrapper"
      showAnimation="fade up"
      hideAnimation="fade up"
      showDuration={500}
      hideDuration={200}
      useMobileDurations={false}
    >
      <div
        className={"mobile-job-filters-modal-container"}
        onClick={(e) => {
          e.stopPropagation();
          setButtonOpen(0);
        }}
      >
        <h3 className="modal-title">Filters</h3>
        <div
          className={
            typeToFilter
              ? "mobile-job-filter-option selected-active"
              : "mobile-job-filter-option"
          }
          onClick={(e) => handleFilterClick(JOB_TYPE_FILTER, e)}
        >
          <span className="modal-option-text">Job type</span>
          <Dropdown
            direction="left"
            style={{
              marginTop: 10,
              backgroundColor: WHITE_COLOUR,
              color: MAIN_COLOUR,
              zIndex: 17,
              width: "100%",
            }}
            className="job-type-filter-input"
            placeholder="Select job type"
            // open={typeToFilter === undefined}
            clearable
            defaultValue={getJobTypeFilter(filters)}
            options={DROP_DOWN_JOB_TYPE_OPTIONS}
            selection
            closeOnBlur={true}
            selectOnBlur={false}
            selectOnNavigation={false}
            onChange={(e, { value }) => handleJobTypeChange(e, { value })}
          />
        </div>
        <div
          className={
            industryToFilter
              ? "mobile-job-filter-option selected-active"
              : "mobile-job-filter-option"
          }
          onClick={(e) => handleFilterClick(INDUSTRY_FILTER, e)}
        >
          {mode === HR_ALL_MODE && (
            <span className="modal-option-text">Industry</span>
          )}
          {mode === HR_HEALTHCARE_MODE && (
            <span className="modal-option-text">Category</span>
          )}
          <Dropdown
            style={{
              marginTop: 10,
              backgroundColor: WHITE_COLOUR,
              color: MAIN_COLOUR,
              zIndex: 15,
              width: "100%",
            }}
            direction="left"
            className="job-industry-filter-dropdown"
            data-testid="industry-dropdown-testid"
            placeholder={
              mode === HR_ALL_MODE ? "Select industry" : "Select category"
            }
            clearable
            defaultValue={getJobIndustryFilter(filters)}
            options={getJobFilterOptions(mode)}
            search
            selection
            closeOnBlur={true}
            selectOnBlur={false}
            selectOnNavigation={false}
            onChange={(e, { value }) => handleIndustryChange(e, { value })}
          />
        </div>
      </div>
      <div className="center-flex">
        <Button
          className={"overwrite-button cta-orange-form"}
          content={"Show results"}
          onClick={() => dispatch(closeModal())}
        />
      </div>
    </ModalWrapper>
  );
}
